import React, { Component } from 'react';
import { Switch, BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';

import IdleTimer from 'react-idle-timer';
// Import Routes
import { authProtectedRoutes, publicRoutes } from './routes/';
import AppRoute from './routes/route';

// layouts
import VerticalLayout from './components/VerticalLayout/';
import NonAuthLayout from './components/NonAuthLayout';

// Import scss
import './theme.scss';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			timeout: 1000 * 60 * 60 * 3,
			showModal: false,
			userLoggedIn: false,
			isTimedOut: false,
		};
		this.getLayout = this.getLayout.bind(this);
		this.idleTimer = null;
		this.onAction = this._onAction.bind(this);
		this.onActive = this._onActive.bind(this);
		this.onIdle = this._onIdle.bind(this);
	}

	/**
	 * Returns the layout
	 */
	getLayout = () => {
		let layoutCls = VerticalLayout;

		switch (this.props.layout.layoutType) {
			default:
				layoutCls = VerticalLayout;
				break;
		}
		return layoutCls;
	};

	_onAction(e) {
		this.setState({ isTimedOut: false });
	}

	_onActive(e) {
		this.setState({ isTimedOut: false });
	}

	_onIdle(e) {
		const isTimedOut = this.state.isTimedOut;
		if (isTimedOut) {
			sessionStorage.clear();
			window.location.reload(false);
			// history.push('/login')
		} else {
			this.setState({ showModal: true });
			this.idleTimer.reset();
			this.setState({ isTimedOut: true });
		}
	}

	render() {
		const Layout = this.getLayout();

		return (
			<React.Fragment>
				<Router>
					{window.location.pathname === '/login' ? (
						<></>
					) : (
						<IdleTimer
							ref={ref => {
								this.idleTimer = ref;
							}}
							element={document}
							onActive={this.onActive}
							onIdle={this.onIdle}
							onAction={this.onAction}
							debounce={250}
							timeout={this.state.timeout}
						/>
					)}
					<Switch>
						{publicRoutes.map((route, idx) => (
							<AppRoute path={route.path} layout={NonAuthLayout} component={route.component} key={idx} isAuthProtected={false} />
						))}

						{authProtectedRoutes.map((route, idx) => (
							<AppRoute path={route.path} layout={Layout} component={route.component} key={idx} isAuthProtected={true} />
						))}
					</Switch>
				</Router>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		layout: state.Layout,
	};
};

export default connect(mapStateToProps, null)(App);
